export type MatchColor = 'red' | 'orange' | 'yellow' | 'green' | 'darkgreen';

export function matchColor(score: number): MatchColor {
  if (score < 10) return 'red';
  if (score < 20) return 'orange';
  if (score < 30) return 'yellow';
  if (score <= 40) return 'green';
  return 'darkgreen';
}
